const groupAssigneeNames = {
    'Group 4': 'Group',
    'kotodox': 'Isak Almgren',
    'RichardG99': 'Richard Götherström',
    'R055A': 'Adam Ross',
    'ViktorYtterborn': 'Viktor Ytterborn'
};

const groupMemberResponsibilities = {
    'Isak Almgren': 'Project Manager, Contributor',
    'Richard Götherström': 'Kanban Admin, Contributor',
    'Adam Ross': 'Technical Admin, Contributor',
    'Viktor Ytterborn': 'Hand-in Admin, Contributor'
};

const projectMilestones = {
    '1': 'Milestone 1 - Week 45',
    '2': 'Milestone 2 - Week 48',
    '3': 'Milestone 3 - Week 50',
    '4': 'Milestone 4 - Week 1'
};

const projectTaskStatus = {
    'Todo': 'Todo',
    'In Progress': 'In Progress',
    'In Review': 'In Review',
    'Done': 'Done'
}

const labelStatus = ['done', 'doing', 'late', 'stuck'];

const sprintWeek = {
    45: 0,
    46: 1,
    47: 2,
    48: 3,
    49: 4,
    50: 5,
    51: 6,
    52: 7,
    1: 8
}

/**
 * Checks if all group members are assigned for returning either ['Group 4'] or the input parameter `assignees` value
 * @param {[string]} assignees array containing GitHub username strings for each group member assigned to a task
 * @returns {string[]} ['Group 4'] if all member usernames are in `assignees` array, otherwise the `assignees` array
 */
const getAllAssignees = (assignees) => {
    return assignees.length === Object.keys(groupAssigneeNames).length - 1 ? [Object.keys(groupAssigneeNames)[0]] : assignees;
}

/**
 * Extract and convert time from string into float format rounded to 2 d.p. representing hours
 * @param {string} str the string the time value is being extracted from
 * @returns {number} extracted time in float format rounded to 2 d.p. representing hours, or 0.0 representing no time
 */
const getTime = (str) => {
    let match = str.match(/(\d+(?:\.\d+)?|\d+\/\d+)\s*(h|hr|hrs|hour|hours)\b/i);
    if (match)
        if (match[1].includes('/')) {
            const [numerator, denominator] = match[1].split('/').map(Number);
            return parseFloat((numerator / denominator).toFixed(2));
        } else {
            return parseFloat(parseFloat(match[1]).toFixed(2));
        }

    const minutesInOneHour = 60;
    match = str.match(/(\d+)\s*(m|min|mins|minute|minutes)\b/i);
    if (match)
        return parseFloat((parseInt(match[1]) / minutesInOneHour).toFixed(2));
    return 0.0
}

export {
    getAllAssignees,
    sprintWeek,
    labelStatus,
    projectTaskStatus,
    projectMilestones,
    groupAssigneeNames,
    getTime,
    groupMemberResponsibilities
};
